export const apiRoutes = {
  auth: {
    refreshToken: 'auth/refresh-token',
    email: {
      login: 'auth/email/public-login',
      register: 'auth/email/register',
      registrationConfirmation: 'auth/email/registration-confirmation',
      passwordChange: 'auth/email/public-password-change',
      passwordResetRequest: 'auth/email/public-password-reset-request',
      passwordReset: 'auth/email/password-reset',
    },
    google: {
      login: 'auth/google/login',
    },
  },
  translations: {
    list: 'translations',
    update: 'translations/:id',
  },
  languages: {
    locale: 'languages/locale/:locale',
    options: 'languages/options',
  },
  userTokens: {
    get: 'user-tokens/:token',
  },
  health: {
    version: 'health/version',
  },
  users: {
    me: 'users/me',
  },
  roles: {
    mappedAccess: 'roles/mapped-access',
  },
  assets: {
    uploadImage: 'assets/upload-image',
    uploadPrivateFile: 'assets/upload-private-file',
    uploadPrivateFiles: 'assets/upload-private-files',
    getAsset: 'assets/owned/:id',
    downloadFile: 'assets/download-file/:id',
    getDownloadableFile: 'assets/get-downloadable-file/:id',
    getOwnedDownloadableFile: 'assets/get-owned-downloadable-file/:id',
  },
  brands: {
    favorite: 'brands/favorite',
    options: 'brands/options/public',
  },
  categories: {
    topNavigation: 'categories/top-navigation',
    topNavigationChildren: 'categories/top-navigation-children',
    categoryByName: 'categories/category-name',
    all: 'categories/catalog',
    homepage: 'categories/homepage',
    children: 'categories/:id/children',
  },
  manufacturers: {
    main: 'manufacturers/main',
  },
  products: {
    getProduct: 'products/:name/:sku/public',
    getProductAuth: 'products/:name/:sku/public/auth',
    getProductCompatability: 'products/:slug/public/:vehicleId/:name',
    getProductBrandModels: 'products/:slug/public/brands/:brandId/models',
    getProductVehicles: 'products/:slug/public/vehicles',
    getProductCategory: 'products/:slug/public/category',
    categoryTeaser: 'products/public/category-teaser/:categoryId',
    searchProducts: 'products/search',
    searchProductsAuth: 'products/search/auth',
    searchFacets: 'products/search/facets',
    cartItems: 'products/cart',
    cartItemsAuth: 'products/cart/auth',
    featuredProducts: 'products/featured',
    topProducts: 'products/top',
    similarProducts: 'products/similar',
    similarProductsAuth: 'products/similar/auth',
    newestProducts: 'products/newest',
    brandProducts: 'products/brand',
  },
  vehicleModels: {
    options: 'vehicle-models/options/public',
  },
  vehicles: {
    options: 'vehicles/options/public',
    addUserVehicle: 'vehicles/user-vehicles/:id',
    selectedVehicle: 'vehicles/:id/selected',
    sendFindVehicleHelpEmail: 'vehicles/find-vehicle-email',
    userVehicles: 'vehicles/user-vehicles',
    getVehiclesByIds: 'vehicles/ids',
    deleteVehicle: 'vehicles/user-vehicles/:id',
    registrationLookup: 'vehicles/registration-lookup',
  },
  carousel: {
    get: 'carousel/info',
  },
  blogs: {
    get: 'blogs/public/:slug',
    getRelatedBlogs: 'blogs/related/:slug',
    getFeaturedBlogs: 'blogs/featured',
    getNewestBlogs: 'blogs/newest',
    getRecentlyReadBlogs: 'blogs/recently-read',
    getBlogsByCategory: '/blogs/public/category',
  },
  articleCategories: {
    get: 'article-categories/public',
    getAllPublic: 'article-categories/public-list',
    getArticleCategory: 'article-categories/:slug/public',
  },
  staticPages: {
    get: 'static-pages/name/:name',
    getAll: 'static-pages/all',
  },
  newsletter: {
    subscribe: 'newsletter',
  },
  order: {
    create: 'orders/public',
    createAnonymous: 'orders/public/anonymous',
    lookupPublic: 'orders/public/lookup',
    downloadInvoice: 'orders/:id/invoice',
  },
  orderItems: {
    getUserOrderItems: 'order-items/me',
  },
  returnOrders: {
    lookupPublic: 'return-orders/public/lookup',
    createPublic: 'return-orders/public',
  },
  bankDetails: {
    getUser: 'bank-details/me',
    saveUser: 'bank-details/me',
  },
  vatRates: {
    public: 'vat-rates/public',
  },
  address: {
    getUserAddresses: 'address/me',
    createUserAddress: 'address/me',
    updateUserAddress: 'address/me/:id',
    deleteUserAddress: 'address/me/:id',
  },
  profile: {
    updateUserProfile: 'profile/update-self',
  },
  basket: {
    createOrUpdateUserBasket: 'baskets/:token',
  },
  faq: {
    getAll: 'faq/all',
    sendFaqHelpEmail: 'faq/help',
  },
  likedProducts: {
    toggleUserLikedProduct: 'liked-products/:id',
    getPaginatedUserLikedProducts: 'liked-products',
    getUserLikedProductsIds: 'liked-products/ids',
    removeAllLikedProducts: 'liked-products',
    likeProducts: 'liked-products/bulk',
  },
  promoCodes: {
    get: 'promo-codes/validate/:code',
  },
  deliveryPrices: {
    getAll: 'delivery-prices/all',
  },
  shippingRates: {
    calculate: 'shipping-rates/calculate',
  },
};
